import { render, staticRenderFns } from "./EventSettings.vue?vue&type=template&id=48e9532e&"
import script from "./EventSettings.vue?vue&type=script&lang=js&"
export * from "./EventSettings.vue?vue&type=script&lang=js&"
import style0 from "./EventSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e9532e')) {
      api.createRecord('48e9532e', component.options)
    } else {
      api.reload('48e9532e', component.options)
    }
    module.hot.accept("./EventSettings.vue?vue&type=template&id=48e9532e&", function () {
      api.rerender('48e9532e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventSettings.vue"
export default component.exports